import React from 'react'
import { HorizontalStack, Spinner } from '@ztechapps/webui.util'

export const LoadingTableStats = () => {
  return (
    <HorizontalStack gap={1}>
      <Spinner size="sm" /> Loading...
    </HorizontalStack>
  )
}
